module.exports = __webpack_public_path__ + "img/ioe-transfer-funds.9a5b0a3e.svg";